<template lang="pug">
    .banner(:class="{ hover: mouseover }")
        // .background(:style="{ background: `url(${image.src}) no-repeat center center` }")
        .background(v-lazy:background-image="image")
        router-link(
            v-if="path"
            :to="path"
            @mouseover.native="hover"
            @mouseleave.native="blur"
        )
            .content
                h4(v-if="banner.sub_title") {{ banner.sub_title }}
                h2(v-if="banner.title") {{ banner.title }}
        a(
            v-else-if="href"
            :href="href"
            :title="banner.title || banner.sub_title"
            :target="target"
            @mouseover="hover"
            @mouseleave="blur"
        )
            .content
                h4(v-if="banner.sub_title") {{ banner.sub_title }}
                h2(v-if="banner.title") {{ banner.title }}
        .content(v-else)
            h4(v-if="banner.sub_title") {{ banner.sub_title }}
            h2(v-if="banner.title") {{ banner.title }}

</template>

<script>

import _ from 'lodash'

export default {
    name: 'Banner',
    data() {
        return {
            delay: 150,
            mouseover: false,
        }
    },
    props: {
        banner: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
    },
    computed: {
        image() {
            const image = _.get(this.banner, 'images.0')
            if (! image) return false

            const storageRoute = _.trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            let fit = _.get(image, 'pivot.fit') || 'fit=crop&crop=focalpoint&x=.5&y=.5&z=1.1111111111'
            const parameters = {
                // ... _.get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... _.get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), 'groups'),
                // ... _.get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), 'groups'),
                ... _.get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), 'groups'),
            }
            let { w, h } = parameters

            if (w && h) {
                const aspectRatio = 17 / 7

                h = 320
                w = h * aspectRatio
                fit = fit.replace(/w=([0-9]+\.?[0-9]*)/, `w=${w}`).replace(/h=([0-9]+\.?[0-9]*)/, `h=${h}`)
            } else if (! w && ! h) {
                h = 320
                fit += `&h=${h}`
            }

            return {
                src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
                error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`,
            }
        },
        hyperlink() {
            return _.get(this.banner, 'hyperlink') || {}
        },
        href() {
            let href = false

            if (this.hyperlink.type !== 'internal' && _.get(this.hyperlink, 'href')) {
                const link = this.hyperlink.href
                switch (this.hyperlink.type) {
                    case 'external':
                        if (! _.startsWith(link, 'https://') && ! _.startsWith(link, 'http://')) href = `https://${link}`
                        else href = link
                        break;

                    case 'mailto':
                        href = `mailto:${link}`
                        break;

                    case 'tel':
                        href = `tel:${link}`
                        break;
                }
            }

            return href
        },
        target() {
            return _.get(this.hyperlink, 'target') || '_self'
        },
        path() {
            if (this.hyperlink.type === 'internal' && _.get(this.hyperlink, 'menuItem.path')) return this.hyperlink.menuItem.path
            else return false
        },
    },
    methods: {
        hover() {
            this.$emit('focus', this.item)
            this.mouseover = true
        },
        blur() {
            setTimeout(() => {
                this.$emit('blur', this.item)
                this.mouseover = false
            }, this.delay);
        },
    },
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";

    .banner
        position: relative
        overflow: hidden
        +desktop
            width: 50%
            float: left
        &.hover
            .background
                transform: scale(1.03)
            .content
                transform: scale(1.06)
        .background
            position: absolute
            background-size: cover !important
            background-position: center center
            transition: transform .8s ease
            transform-origin: 30% 70% 0
            width: 100%
            height: 100%
            z-index: -1
        .content
            height: 350px
            padding: 60px
            text-shadow: 0 1px 3px #333333
            display: flex
            flex-direction: column
            justify-content: flex-end
            transform-origin: 30% 50% 0
            transition: transform .8s ease
            background: linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.3) 75%)
            h2, h4
                color: #ffffff
                margin: 0
                padding: 0
            h4
                text-transform: uppercase
                font-size: .85rem
            h2
                margin-top: 10px
                font-size: 2.6rem
                font-weight: 300
</style>
